import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { reduxForm, getFormValues } from "redux-form";
import _ from "lodash";
import moment from "moment";
import toast from "react-hot-toast";
import { fetchCheckoutForm, openRegistration } from "@registrationaction";
import { fetchEventInterests, fetchAppuserCount } from "@mainaction";
import { DATE_FORMAT, DISPLAY_BROWSER_DATE_FORMAT } from "@datehandle";
import { CDN_BASE_IMAGES_URL } from "@constant";
import {
  validateEmail,
  validateUrl,
  checkDateFormatYMD,
  validatePhoneNumbers,
} from "@utilscommon";
import { handleShowHide } from "@fieldshowhide";
import Loader from "@loader";
import ProtectedScreen from "./components/protected-screen";
import OldFormPage from "./components/old-form-page";
import SectionWisePage from "@sectionwisepages";
import LocaleStrings from "@language";

const Registration = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { formid } = useParams();
  const {
    session,
    eventData,
    eventSettingsData,
    checkoutFormData,
    sectionWiseArray,
    protectedPage,
    appuserCount,
    formArray,
    handleSubmit,
    pristine,
    invalid,
    submitting,
    autofill,
    formValues,
    formErrors,
  } = props;
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    let data = { eventid: eventData?.eventid };
    let filter = { eventid: eventData?.eventid };
    if (formid) {
      data.formid = formid;
    }

    props.fetchCheckoutForm(session, data, (res) => {
      setApiResponse(res);
    });
    if (
      eventSettingsData?.data?.eventcapacity > 0 &&
      eventSettingsData?.data?.waitlistmode === false
    ) {
      props.fetchAppuserCount(session, filter, () => {});
    }

    props.fetchEventInterests(session, () => {});
  }, [eventData?.eventid, formid]);

  const fetchImageAsBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const onSubmitForm = async (data) => {
    // console.log("data :- ", data);

    let error = validate(data, props);
    if (_.isEmpty(error)) {
      let eventCapacity = eventSettingsData?.data?.eventcapacity;
      let eventWaitlistMode = eventSettingsData?.data?.waitlistmode; // true/false, check the event waitlist mode

      // Check event capacity and not allow user registration if capacity is full
      if (eventCapacity > 0 && eventWaitlistMode === false) {
        let totalAppuser = appuserCount?.data?.totalusers;

        if (totalAppuser >= eventCapacity) {
          toast.error(LocaleStrings.kEventCapacityFullRegistrationText);
          return;
        }
      }

      let values = {
        profileurl: data?.profileurl ?? "",
        firstname: data?.firstname?.trim(),
        lastname: data?.lastname?.trim(),
        interest: data?.interest ? _.uniqBy(data?.interest) : [], // Removing duplicate interest IDs
        isnetworking: data?.isnetworking ?? 0,
      };
      if (data?.signupwith === "phonenumber") {
        values.email = "";
        values.phonenumber = data?.phonenumber?.trim();
      } else {
        values.phonenumber = "";
        values.email = data?.email?.trim().toLowerCase();
      }

      // Check if profileurl is a link and convert to base64
      const isURL = (str) => {
        try {
          new URL(str);
          return true;
        } catch {
          return false;
        }
      };

      if (isURL(values.profileurl)) {
        try {
          values.profileurl = await fetchImageAsBase64(values.profileurl);
        } catch (error) {
          console.error("Error converting profile URL to base64:", error);
        }
      }

      if (data?.rsvpsessions && data?.rsvpsessions?.length > 0) {
        values.rsvpsessions = data?.rsvpsessions ?? [];
      }

      let formData = [];
      _.map(formArray, (form) => {
        let formKey = form?.key;
        let name = form?.name;
        let isReadOnly = form?.isreadonly ?? false;
        let isHidden = form?.hidden ?? false;

        if (
          formKey !== "label" &&
          formKey !== "hyperlink" &&
          formKey !== "paragraph" &&
          formKey !== "section"
        ) {
          if (data.hasOwnProperty(name)) {
            if (formKey === "datepicker") {
              let date = "";
              if (data[name] && typeof data[name] === "string") {
                if (checkDateFormatYMD(data[name])) {
                  let dateParse = new Date(Date.parse(data[name]));
                  date = moment(dateParse).format(DATE_FORMAT);
                } else {
                  date = moment(data[name], DISPLAY_BROWSER_DATE_FORMAT).format(
                    DATE_FORMAT
                  );
                }
                if (!moment(date).isValid()) {
                  date = "";
                }
              } else {
                date = moment(data[name]).format(DATE_FORMAT);
              }
              form.value = !isReadOnly && !isHidden ? date : "";
            } else if (formKey === "dropdown") {
              let checkType = typeof data[name];
              let val = "";
              if (checkType === "object") {
                val = data?.[name]?.value ?? "";
              } else {
                val = data?.[name] ?? "";
              }
              form.value = !isReadOnly && !isHidden ? val : "";
            } else if (formKey === "dynamicfield" && name === "interest") {
              // No value need to store here.
            } else {
              form.value = !isReadOnly && !isHidden ? data[name] : "";
              if (formKey === "checkboxes" || formKey === "file") {
                form.value = !isReadOnly && !isHidden ? data[name] : [];
              }
            }
          } else {
            if (formKey === "checkboxes" || formKey === "file") {
              form.value = [];
            } else if (formKey === "dynamicfield" && name === "interest") {
              // No value need to store here.
            } else {
              form.value = "";
            }
          }
        }

        formData.push(form);
      });
      // console.log("formData :- ", formData);

      values.eventid = checkoutFormData?.data?.eventid;
      values.formid = checkoutFormData?.data?.formid;
      values.responses = JSON.stringify(formData);

      // console.log("Final Value :- ", values);
      // return;

      // Get external thankyou page
      let link = "";
      if (eventSettingsData?.data?.thankyoulink) {
        let linkVal = eventSettingsData?.data?.thankyoulink;
        if (linkVal.search("http") === -1) {
          link = `http://${linkVal}`;
        } else {
          link = linkVal;
        }
      }
      let param = location.search;

      setLoading(true);
      props.openRegistration(session, values, (response) => {
        // console.log("response :- ", response);

        setLoading(false);
        if (response.success === 1) {
          const platform = new URLSearchParams(window.location.search).get(
            "platform"
          );

          if (platform === "kiosk") {
            if (
              window.ReactNativeWebView &&
              response?.data?.resource?.appuserid
            ) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  appuserid: response?.data?.resource?.appuserid,
                })
              );
            }
          }
          eventSettingsData?.data?.thankyoulink
            ? (window.location.href = link)
            : navigate(`/thank-you${param}`, {
                state: {
                  ...(response?.data?.resource ?? {}),
                  source: "registration",
                },
              });
        } else if (response.success === 2) {
          if (response?.errors?.code === "invalid_payload") {
            toast.error(
              _.replace(
                LocaleStrings.kInvalidPayloadText,
                "#missed",
                response?.errors?.resource?.missed
              )
            );
          } else if (response?.errors?.code === "invalid_email") {
            toast.error(LocaleStrings.kInvalidEmail);
          } else if (response?.errors?.code === "invalid_event_checkout") {
            toast.error(LocaleStrings.kInvalidCheckoutFormText);
          } else if (
            response?.errors?.code === "event_registration_date_fail"
          ) {
            toast.error(LocaleStrings.kEventRegDateFailText);
          } else if (response?.errors?.code === "email_domain_not_allowed") {
            toast.error(
              _.replace(
                LocaleStrings.kInvalidEmailDomainText,
                "###DOMAIN###",
                response?.errors?.resource?.domain
              )
            );
          } else if (response?.errors?.code === "email_alreay_registered") {
            toast.error(LocaleStrings.kEmailAlreadyRegisteredText);
          } else if (response?.errors?.code === "organizer_credit_limit_used") {
            toast.error(LocaleStrings.kHostCreditLimitUsedText);
          } else if (response?.errors?.code === "event_capacity_full") {
            toast.error(LocaleStrings.kEventCapacityFullRegistrationText);
          } else if (response?.errors?.code === "capacity_full") {
            toast.error(LocaleStrings.kEventCapacityFullText);
          } else if (response?.errors?.code === "session_seat_full") {
            toast.error(
              _.replace(
                LocaleStrings.kSessionSeatFullText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else if (
            response?.errors?.code ===
            "same_track_multiple_session_rsvp_not_allowed"
          ) {
            toast.error(
              _.replace(
                LocaleStrings.kSameTrackSessionRSVPNotAllowedText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else if (
            response?.errors?.code === "common_time_session_rsvp_not_allowed"
          ) {
            toast.error(
              _.replace(
                LocaleStrings.kCommonTimeSessionRSVPNotAllowedText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else {
            toast.error(LocaleStrings.kEmailAlreadyRegisteredText);
          }
        } else if (response.success === 3) {
          toast.error(LocaleStrings.kProfilePicNotUploadedText);
        } else {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        }
      });
    } else {
      toast.error(LocaleStrings.kRequiredFieldAlert);
    }
  };

  // console.log("apiResponse :- ", apiResponse);
  // console.log("formValues :- ", formValues);
  // console.log("formErrors :- ", formErrors);
  // console.log("checkoutFormData :- ", checkoutFormData);
  // console.log("protectedPage :- ", protectedPage);
  let allowRegi = protectedPage?.allowregistration ?? false;

  return (
    <>
      {checkoutFormData?.data ? (
        <>
          {!_.isEmpty(checkoutFormData?.data) ? (
            <>
              {allowRegi ? (
                <>
                  <div className="content-body">
                    {checkoutFormData?.data?.formimage ? (
                      <img
                        className="header-image-view"
                        src={`${CDN_BASE_IMAGES_URL}/${checkoutFormData.data.formimage}`}
                        alt="registration-logo"
                      />
                    ) : (
                      ""
                    )}

                    {checkoutFormData?.data?.description ? (
                      <div
                        className="custom-text-secondary-md-normal mb-4 sm:mb-6 lg:mb-8"
                        dangerouslySetInnerHTML={{
                          __html: checkoutFormData?.data?.description.replace(
                            /\n/g,
                            "<br>"
                          ),
                        }}
                      />
                    ) : (
                      ""
                    )}

                    <form onSubmit={handleSubmit(onSubmitForm)}>
                      {sectionWiseArray?.length > 0 ? (
                        <>
                          {/* Section wise form display */}
                          <SectionWisePage
                            source="registration"
                            autofill={autofill}
                            formValues={formValues}
                            formErrors={formErrors}
                            btnLoading={loading}
                            pristine={pristine}
                            invalid={invalid}
                            submitting={submitting}
                            formSubmit={onSubmitForm}
                          />
                        </>
                      ) : (
                        <>
                          {/* Old form page display */}
                          <OldFormPage
                            autofill={autofill}
                            formValues={formValues}
                            btnLoading={loading}
                            pristine={pristine}
                            invalid={invalid}
                            submitting={submitting}
                          />
                        </>
                      )}
                    </form>
                  </div>
                </>
              ) : (
                <div className="content-body">
                  <ProtectedScreen />
                </div>
              )}
            </>
          ) : (
            <div className="p-4 text-3xl font-bold text-primary min-h-inherit flex items-center justify-center text-center">
              {apiResponse?.success === 2
                ? apiResponse?.errors?.code === "invalid_event"
                  ? LocaleStrings.kInvalidEventText
                  : apiResponse?.errors?.code === "organizer_credit_limit_used"
                  ? LocaleStrings.kHostCreditLimitUsedText
                  : LocaleStrings.kInvalidCheckoutFormText
                : LocaleStrings.kSomethingWentWrongMsg}
            </div>
          )}
        </>
      ) : (
        <div className="content-body">
          <Loader />
        </div>
      )}
    </>
  );
};

function validate(values, ownProps) {
  let checkoutFormData = ownProps?.checkoutFormData?.data;
  let formArray = ownProps?.formArray;
  let allConditionalFields = ownProps?.allConditionalFields;
  let sectionWiseArray = ownProps?.sectionWiseArray;
  const custom_settings = JSON.parse(
    ownProps?.eventSettingsData?.data?.custom_settings ?? "{}"
  );
  const rsvpMandatory = custom_settings?.rsvp_mandatory ?? false;
  const allowPhoneSignup = custom_settings?.enable_phone_based_login ?? false;

  // console.log("checkoutFormData :- ", checkoutFormData);
  // console.log("allConditionalFields :- ", allConditionalFields);
  // console.log("sectionWiseArray :- ", sectionWiseArray);

  let profileOptionn = checkoutFormData?.profileimage ?? "optional";
  let allowedEmailDomain =
    checkoutFormData?.allowemaildomain &&
    checkoutFormData?.allowemaildomain !== ""
      ? checkoutFormData?.allowemaildomain.trim()
      : "";

  let errors = {};
  let signupwith = values?.signupwith ?? "email";
  let email = values?.email;
  let phonenumber = values?.phonenumber;
  let profileurl = values?.profileurl;
  let firstname = values?.firstname;
  let lastname = values?.lastname;
  if (!allowPhoneSignup) {
    signupwith = "email";
  }

  if (ownProps.generalRSVPSessions?.length > 0 && rsvpMandatory) {
    let rsvpsessions = values?.rsvpsessions ?? [];
    if (rsvpsessions?.length === 0) {
      errors["rsvpsessionserror"] = LocaleStrings.kFieldRequired;
    }
  }
  if (profileOptionn === "mandatory" && !profileurl) {
    errors["profileurl"] = LocaleStrings.kFieldRequired;
  }
  if (!firstname || firstname.trim() === "") {
    errors["firstname"] = LocaleStrings.kFieldRequired;
  } else if (firstname && firstname.search('"') >= 0) {
    errors["firstname"] = LocaleStrings.kDoubleQuotesNotAllowedText;
  }
  if (!lastname || lastname.trim() === "") {
    errors["lastname"] = LocaleStrings.kFieldRequired;
  } else if (lastname && lastname.search('"') >= 0) {
    errors["lastname"] = LocaleStrings.kDoubleQuotesNotAllowedText;
  }

  if (signupwith === "phonenumber") {
    if (!phonenumber) {
      errors["phonenumber"] = LocaleStrings.kFieldRequired;
    } else if (!validatePhoneNumbers(phonenumber) || phonenumber.length < 10) {
      errors["phonenumber"] = LocaleStrings.kInvalidPhoneText;
    }
  } else {
    if (!email || email.trim() === "") {
      errors["email"] = LocaleStrings.kFieldRequired;
    } else {
      email = email.trim();

      if (!validateEmail(email)) {
        errors["email"] = LocaleStrings.kInvalidEmail;
      } else {
        if (validateEmail(email) && allowedEmailDomain !== "") {
          let emailDomain = email?.split("@")?.[1];
          emailDomain = emailDomain.toLowerCase();
          let domainArray = allowedEmailDomain.split(",");
          domainArray = domainArray.map((o) => o.toLowerCase());
          // console.log("emailDomain :- ", emailDomain);
          // console.log("domainArray :- ", domainArray);
          if (!_.includes(domainArray, emailDomain)) {
            errors["email"] = _.replace(
              LocaleStrings.kInvalidEmailDomainText,
              "###DOMAIN###",
              emailDomain
            );
          }
        }
      }
    }
  }

  let currentSection = [];
  _.map(formArray, (form, index) => {
    let key = form?.key;
    let name = form?.name;
    let isReadOnly = form?.isreadonly ?? false;
    let isHidden = form?.hidden ?? false;
    let isRequired = form?.required && !isReadOnly && !isHidden ? true : false;
    let isExclude = form?.exclude ?? false;
    if (key === "section") {
      // check current section and updated the currentSection veriable
      let check = _.filter(sectionWiseArray, (o) => o.name === name);
      currentSection = check.length > 0 ? check[0] : [];
    }
    // console.log("currentSection :- ", currentSection);

    let relatedWith = [];
    allConditionalFields.forEach((item) => {
      let fName = item.name;
      let fKey = item.key;
      let options = item.options;
      let check = _.filter(options, (val) => {
        return val?.displayfields.indexOf(name) > -1;
      });
      // console.log("check :- ", name, check);

      if (check.length > 0) {
        let val = [];
        check.forEach((v) => {
          val.push(v?.value);
        });

        relatedWith.push({
          key: fKey,
          name: fName,
          value: val,
        });
      }
    });
    // console.log(name, relatedWith);

    // Check field is hidden or not
    let ishidden = handleShowHide(
      name,
      ownProps.formValues,
      ownProps.autofill,
      null,
      allConditionalFields,
      sectionWiseArray
    );
    // console.log("field active  :- ", name, ishidden);

    // Check currect fields parent section status
    let isSectionHidden = 0;
    if (key !== "section") {
      let currentSectionFields = currentSection?.elements ?? [];
      let currentSectionName = currentSection.name;

      let check = _.filter(currentSectionFields, (o) => o.name === name);
      if (check.length > 0) {
        // Check current field parent section is hidden or not
        isSectionHidden = handleShowHide(
          currentSectionName,
          ownProps.formValues,
          ownProps.autofill,
          null,
          allConditionalFields
        );
      }
    }

    if (!isExclude && ishidden === 0 && isSectionHidden === 0) {
      if (isRequired && !values[name]) {
        // Check either this filed linked with other fields or not
        if (relatedWith.length > 0) {
          let match = [];
          _.map(relatedWith, (rel) => {
            if (values[rel?.name]) {
              // console.log("option val :- ", values[rel?.name]);
              if (rel?.key === "checkboxes") {
                let common = _.intersection(values[rel?.name], rel?.value);
                match = _.concat(match, common);
              } else {
                let common = _.filter(
                  rel?.value,
                  (o) => o === values[rel?.name]
                );
                match = _.concat(match, common);
              }
            }
          });
          // console.log("match :- ", name, match);
          if (match.length > 0) {
            // console.log(name, "Required...........................");
            errors[name] = LocaleStrings.kFieldRequired;
          }
        } else {
          errors[name] = LocaleStrings.kFieldRequired;
        }
      } else if (isRequired && values[name]) {
        let valueType = typeof values[name];
        // console.log("valueType :- ", valueType);

        if (key !== "datepicker" && valueType !== "boolean") {
          if (valueType === "string" && values[name].trim() === "") {
            errors[name] = LocaleStrings.kFieldRequired;
          } else if (_.isEmpty(values[name])) {
            errors[name] = LocaleStrings.kFieldRequired;
          }
        }
      }
      if (
        (name === "facebook" || name === "twitter" || name === "linkedin") &&
        values[name] &&
        !validateUrl(values[name])
      ) {
        errors[name] =
          name === "facebook"
            ? LocaleStrings.kInvalidFacebookLinkText
            : name === "twitter"
            ? LocaleStrings.kInvalidTwitterLinkText
            : name === "linkedin"
            ? LocaleStrings.kInvalidLinkedinLinkText
            : LocaleStrings.kInvalidUrlText;
      }
      // if (
      //   (name === "isnetworking" || name === "termsconditions") &&
      //   !values[name]
      // ) {
      //   errors[name] = LocaleStrings.kFieldRequired;
      // }
      if (
        form?.maxlen &&
        values?.[name] &&
        values?.[name]?.length > form?.maxlen
      ) {
        errors[name] = `${_.replace(
          LocaleStrings.kTextMaxLengthText,
          "#maxlength",
          form?.maxlen
        )}`;
      }
      if (
        (name === "phonenumber" || name === "whatsapp") &&
        values?.[name] &&
        !validatePhoneNumbers(values?.[name])
      ) {
        errors[name] = LocaleStrings.kInvalidPhoneText;
      }
    }
  });

  // console.log("errors :- ", errors);
  return errors;
}

const mapStateToProps = (state) => {
  let initVal = { signupwith: "email" };

  return {
    session: state.session,
    initialValues: initVal,
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
    checkoutFormData: state.checkoutFormData,
    formArray: state.formArray,
    sectionWiseArray: state.sectionWiseFormArray,
    allConditionalFields: state.allConditionalFields,
    protectedPage: state.protectedPage,
    appuserCount: state.appuserCount,
    generalRSVPSessions: state.generalRSVPSessions.data || [],

    formValues: getFormValues("RegistrationForm")(state),
    formErrors: state?.form?.["RegistrationForm"]?.syncErrors ?? {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchCheckoutForm,
      openRegistration,
      fetchEventInterests,
      fetchAppuserCount,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "RegistrationForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Registration)
);
